<template>
	<section class="MobileAppPage">
		<header class="Header">
			<a class="Header-logo" href="/">
				<img src="/map/dist/skin/logo.svg" alt="Logo"/>
			</a>
			<span
				v-if="isLoading"
				style="color: #777777; font-size: 13px; position: absolute; display: flex; justify-content: center; align-items: center; left: 50%; top: 5px; margin-left: -15px; background: #ffffff; box-shadow: 0 2px 5px rgba(0,0,0,0.5); border-radius: 9999px; width: 30px; height: 30px;"
			>
				<LoadingIndicator style="height: 16px;"/>
			</span>
		</header>
		<div class="Subheader">
			<Button class="header-buttons" @click="previousDay" :disabled="activeDate === minDate">
				<ArrowLeftIcon
					size="24"
				/>
			</Button>
			<Button
				class="header-buttons" :primary="true" @click="toDay" style="width: 100%; max-width: 300px; text-align:
			center;"
			>{{
					formattedDate(activeDate)
				}}
			</Button>
			<Button class="header-buttons" @click="nextDay" :disabled="activeDate === maxDate">
				<ArrowRightIcon size="24"/>
			</Button>
		</div>
		<main class="MobileAppPage-main" ref="main">
			<div class="Appointments">
				<div v-if="!isLoading && companies.length === 0" class="Appointments__Empty Card">
					<CalendarIcon size="10x" color="#ddd"/>
					<div style="margin: 1em 0;">Geen afspraken gevonden</div>
				</div>
				<div
					v-for="company in companies"
					:key="company.id"
					class="appointment"
					@click="$router.push({ name: 'appointmentdetail', params: {id: company.id} })"
				>
					<div class="phone-section">
						<a
							class="icon"
							:class="{disabled: company.phone == null && company.mobile == null}"
							:href="company.phone == null && company.mobile == null ? '' : `tel:${company.phone != null
               ? company.phone : company.mobile}`"
							@click.stop=""
						>
							<Phone-icon/>
						</a>
						<span>
							{{ company.salutation }} {{ company.companyname }}
							<br/>
							{{ company.customfield_afspraakisolatie }}
							<br/>
							{{ company.customfield_afspraakwoningtype }}
						</span>
					</div>
					<div class="location-section">
						<a
							class="icon"
							:class="{disabled: company.locationUrl == null}"
							:href="company.locationUrl == null ? '' : company.locationUrl"
							target="_blank"
							@click.stop=""
						>
							<Navigation-icon/>
						</a>
						<span>
							{{ company.visitingaddress_street }} {{ company.visitingaddress_streetnumber }}
							<br/>
							{{ company.visitingaddress_zipcode }}
							<br/>
							{{ company.visitingaddress_city }}
						</span>
					</div>
					<div class="time-section">
						<span>
							{{
								company.customfield_afspraaktijdstip != null
									? company.customfield_afspraaktijdstip.substring(0, 5) : "-"
							}}
						</span>
					</div>
				</div>
			</div>
		</main>
		<div class="Footer">
			<Button
				class="Footer-availability-button"
				v-if="allowedTo(['doorgeven/ziekte', 'doorgeven/verlof'])"
				@click="$router.push({name: 'doorgeven'})">
				Doorgeven
			</Button>
			<form class="Footer-search" @submit.prevent="searchForKeyword">
				<input
					class="TextField"
					v-on:input="debounceCallback()"
					style="margin: 0;"
					type="search"
					name="keywords"
					v-model="keywords"
					autocomplete="false"
					placeholder="RELATIE ZOEKEN"
				/>
				<Button type="submit">
					<SearchIcon size="14"/>
				</Button>
			</form>
		</div>
	</section>
</template>

<script>
import Button from "@/components/Button";
import LoadingIndicator from "@/components/LoadingIndicator";
import _ from "lodash";
import moment from "moment";
import "moment/locale/nl";
import {
	ArrowLeftIcon,
	ArrowRightIcon,
	CalendarIcon,
	LogOutIcon,
	NavigationIcon,
	PhoneIcon,
	RefreshCwIcon,
	SearchIcon
} from "vue-feather-icons";
import {mapActions, mapGetters, mapState} from "vuex";

export default {
	components: {
		Button,
		LoadingIndicator,
		PhoneIcon,
		NavigationIcon,
		RefreshCwIcon,
		LogOutIcon,
		ArrowLeftIcon,
		ArrowRightIcon,
		CalendarIcon,
		SearchIcon
	},

	data() {
		return {
			active: null,
			activeDate: moment().format("YYYY-MM-DD"),
			maxDate: moment().add(2, "days").format("YYYY-MM-DD"),
			minDate: moment().subtract(14, "days").format("YYYY-MM-DD"),
			showSearch: false,
			debounceCallback: null,
			keywords: ""
		};
	},

	created() {
		this.debounceCallback = _.debounce(value => {
			this.setFilter();
		}, 300);
	},

	watch: {
		"$route.query.filter"() {
			this.refresh();
		}
	},

	mounted() {
		this.hydrateState();
		this.refresh();
		this.periodical = setInterval(() => {
			this.refresh();
		}, 60000);
	},

	destroyed() {
		clearTimeout(this.periodical);
	},

	computed: {
		...mapState({
			isLoading: "loading"
		}),
		...mapState("auth", {
			viewer: "viewer"
		}),
		...mapState("mobile", {
			companies: "companies"
		}),
		...mapGetters({
			allowedTo: "auth/allowedTo"
		}),

		formattedDate: () => date => {
			return moment(date, "YYYY-MM-DD").format("dd, D MMM YYYY");
		}
	},

	methods: {
		...mapActions({
			logoutUser: "auth/logoutUser",
			getCompaniesWithAppointment: "mobile/getCompaniesWithAppointment"
		}),

		doLogout() {
			this.logoutUser();
			this.$router.push({name: "login"}).catch((error) => {
				if (error) console.error(error);
			});
		},

		setFilter() {
			const filter = btoa(JSON.stringify({
				date: this.keywords === "" ? this.activeDate : null,
				keywords: this.keywords,
				ownAppointmentsOnly: this.keywords === ""
			}));
			this.$router.push({query: {filter: filter}}).catch((error) => {
				if (error) console.error(error);
			});
		},

		hydrateState() {
			const filter = this.$route.query.filter;
			if (filter) {
				const decoded = JSON.parse(atob(filter));
				this.activeDate = decoded.date;
				this.keywords = decoded.keywords;
			}
		},

		refresh() {
			const filter = this.$route.query.filter ? JSON.parse(atob(this.$route.query.filter)) : {
				date: this.activeDate,
				keywords: "",
				ownAppointmentsOnly: true
			};
			this.getCompaniesWithAppointment(filter);
		},

		toDay() {
			this.activeDate = moment().format("YYYY-MM-DD");
			this.keywords = "";
			this.$refs.main.scrollTo({
				top: 0,
				left: 0
			});
			this.setFilter();
		},

		previousDay() {
			if (this.activeDate === this.minDate) {
				return;
			}
			this.activeDate = moment(this.activeDate, "YYYY-MM-DD").subtract(1, "days").format("YYYY-MM-DD");
			this.keywords = "";
			this.$refs.main.scrollTo({
				top: 0,
				left: 0
			});
			this.setFilter();
		},

		nextDay() {
			if (this.activeDate === this.maxDate) {
				return;
			}
			this.activeDate = moment(this.activeDate, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD");
			this.keywords = "";
			this.$refs.main.scrollTo({
				top: 0,
				left: 0
			});
			this.setFilter();
		},

		searchForKeyword() {
			this.$refs.main.scrollTo({
				top: 0,
				left: 0
			});
			this.setFilter();
		},

		clearKeyword() {
			if (this.keywords === "") return;
			this.keywords = "";
			this.$refs.main.scrollTo({
				top: 0,
				left: 0
			});
			this.setFilter();
		}
	}
};
</script>

<style scoped>

.Header {
	justify-content: center;
}

.Footer {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 10;
	display: flex;
	flex-direction: column;
}

.Footer-availability-button {
	font-weight: 800;
	min-width: 15%;
	border-radius: 4px;
	text-align: center;
	margin-left: auto;
	margin-right: 16px;
	margin-bottom: 16px;
}

.Footer input {
	height: 36px;
	font-size: 1rem;
	padding-left: 8px;
	width: 100%;
	border: none;
	border-radius: 5px;
	color: #ffffff;
	background: #006767;
	box-shadow: none;
}

input[type="search"]::-webkit-search-cancel-button {
	-webkit-appearance: none;
	cursor: pointer;

	height: 16px;
	width: 16px;
	background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iNDgiIGhlaWdodD0iNDgiCnZpZXdCb3g9IjAgMCA0OCA0OCIKc3R5bGU9IiBmaWxsOiNmZmZmZmY7Ij48cGF0aCBkPSJNIDM5LjQ4NjMyOCA2Ljk3ODUxNTYgQSAxLjUwMDE1IDEuNTAwMTUgMCAwIDAgMzguNDM5NDUzIDcuNDM5NDUzMSBMIDI0IDIxLjg3ODkwNiBMIDkuNTYwNTQ2OSA3LjQzOTQ1MzEgQSAxLjUwMDE1IDEuNTAwMTUgMCAwIDAgOC40ODQzNzUgNi45ODQzNzUgQSAxLjUwMDE1IDEuNTAwMTUgMCAwIDAgNy40Mzk0NTMxIDkuNTYwNTQ2OSBMIDIxLjg3ODkwNiAyNCBMIDcuNDM5NDUzMSAzOC40Mzk0NTMgQSAxLjUwMDE1IDEuNTAwMTUgMCAxIDAgOS41NjA1NDY5IDQwLjU2MDU0NyBMIDI0IDI2LjEyMTA5NCBMIDM4LjQzOTQ1MyA0MC41NjA1NDcgQSAxLjUwMDE1IDEuNTAwMTUgMCAxIDAgNDAuNTYwNTQ3IDM4LjQzOTQ1MyBMIDI2LjEyMTA5NCAyNCBMIDQwLjU2MDU0NyA5LjU2MDU0NjkgQSAxLjUwMDE1IDEuNTAwMTUgMCAwIDAgMzkuNDg2MzI4IDYuOTc4NTE1NiB6Ij48L3BhdGg+PC9zdmc+') 50% 50% no-repeat;
}

.Footer input::placeholder {
	color: #eeeeee;
}

.Footer button {
	background: #006767;
	color: #ffffff;
}

.Footer-search {
	padding-left: 8px;
	display: flex;
	flex: 1;
	align-items: center;
	background: #006767;
}

.Subheader {
	position: relative;
	top: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	z-index: 11;
	background: #eeeeee;
	color: #000000;
}

.MobileAppPage-main {
	z-index: 0;
	position: relative;
	height: calc(100vh - 88px);
	overflow: auto;
	background: rgb(238, 238, 238);
	padding-bottom: 3em;
}

.Appointments {
	max-width: 800px;
	margin: 0 auto;
}

.Appointments__Empty {
	margin: 1em 0;
	padding: 2em;
	text-align: center;
	color: #aaaaaa;
}

h2, h3 {
	margin: 0 0 0.5em 0;
}

.appointment {
	display: grid;
	background-color: #ffffff;
	border-bottom: 2px solid #eeeeee;
	grid-template-areas:
        "phone time"
        "location time";
	padding: 4px 0;
	color: #000000;
	cursor: pointer;
}

.appointment:nth-last-child(1) {
	margin-bottom: 150px;
}

.phone-section {
	grid-area: phone;
	display: flex;
	margin: 4px 8px;
	align-items: center;
}

.location-section {
	grid-area: location;
	display: flex;
	margin: 4px 8px;
	align-items: center;
}

.time-section {
	grid-area: time;
	display: flex;
	align-self: center;
	justify-content: flex-end;
	margin-right: 16px;
	align-items: center;
}

.time-section span {
	font-size: 2rem;
	font-weight: 900;
}

.icon {
	min-width: 60px;
	width: 60px;
	min-height: 60px;
	height: 60px;
	display: flex;
	justify-content: center;
	align-items: center;
	text-decoration: none;
	color: #ffffff;
	border-radius: 8px;
	margin-right: 16px;
}

.icon.disabled {
	opacity: 0.5;
	cursor: not-allowed;
	text-decoration: none;
	pointer-events: none;
}

.phone-section .icon {
	background: #1f88e5;
}

.location-section .icon {
	background: #35a5a4;
}

.icon path {
	fill: #ffffff;
}

.icon polygon {
	fill: #ffffff;
}

.header-buttons {
	background: #eeeeee;
	border: none;
	box-shadow: none;
	color: #000000;
	font-size: 1rem;
	font-weight: 800;
	text-align: center;
}

.Header-logo {
	display: flex;
	height: 100%;
	width: 100%;
	min-height: 44px;
	align-items: center;
	justify-content: center;
}
</style>
